import React, { useContext, useMemo } from "react";
import { injectIntl } from "react-intl";

import { FixtureDetailsContext } from "../../Config/FixtureDetails";

const GameRules = ({ intl: { formatMessage } }) => {
  const { fixtureProfile, sport } = useContext(FixtureDetailsContext);

  const customPeriodItems = useMemo(() => {
    if (!fixtureProfile?.usePeriodLengthCustomized || !fixtureProfile?.periodLengthCustomized) {
      return [];
    }
    return Object.entries(fixtureProfile.periodLengthCustomized).map(([key, value]) => {
      const periodNum = Number(key);
      const isOvertime = periodNum >= fixtureProfile.initialExtraPeriodId;
      const label = isOvertime ? formatMessage(
          { id: "period.overtime.abbreviation", defaultMessage: "OT{period}" },
          { period: periodNum - fixtureProfile.initialExtraPeriodId + 1 }
        )
        : formatMessage(
          { id: "period.full", defaultMessage: "Period {period}" },
          { period: periodNum }
        );
      return {
        label,
        value: `${value} ${formatMessage({
          id: value === 1 ? "time.minute" : "time.minutes",
          defaultMessage: value === 1 ? "minute" : "minutes"
        })}`
      };
    });
  }, [fixtureProfile.periodLengthCustomized]);

  return (
    <div className="game-details--game-rules">
      <div className="game-details--section-header">
        {formatMessage({
          id: "details.gameRules",
          defaultMessage: "Game Rules",
        })}
      </div>
      <ul className="game-details--game-rules-list">
        <li>
          {`${formatMessage({
            id: "details.gameRules.numberOfPeriods",
            defaultMessage: "No. of periods",
          })}:`}
          <span>{fixtureProfile.numberOfPeriods}</span>
        </li>
        <li>
          {`${formatMessage({
            id: "details.gameRules.periodLength",
            defaultMessage: "Period length",
          })}:`}
          {customPeriodItems.length > 0 ? (
            customPeriodItems.map(({ label, value }) => (
              <span key={label}>{label}: {value}</span>
            ))
          ) : (
            <span>{`${fixtureProfile.periodLength} ${formatMessage({
              id: "time.minutes",
              defaultMessage: "minutes",
            })}`}</span>
          )}
        </li>
        {sport === "basketball" && (
          <>
            {fixtureProfile.overtimeAllowed && (
              <li>
                {`${formatMessage({
                  id: "details.gameRules.overtimeLength",
                  defaultMessage: "Overtime length",
                })}:`}
                <span>{`${fixtureProfile.overtimeLength} ${formatMessage({
                  id: "time.minutes",
                  defaultMessage: "minutes",
                })}`}</span>
              </li>
            )}
            <li>
              {`${formatMessage({
                id: "details.gameRules.foulsBeforeBonus",
                defaultMessage: "Fouls before bonus",
              })}:`}
              <span>{fixtureProfile.foulsBeforeBonus}</span>
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default injectIntl(GameRules);
